var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWebsite = function SvgWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282830",
    fillRule: "evenodd",
    d: "M15.283 3.532a.4.4 0 0 0-.566-.565L12.92 4.763a4.9 4.9 0 0 0-6.907 6.907l-1.796 1.797a.4.4 0 0 0 .566.566l.578-.579a6.62 6.62 0 0 0 3.889 1.44v.95H8.8a.4.4 0 1 0 0 .8h1.7a.4.4 0 0 0 0-.8h-.45v-.967A6.65 6.65 0 0 0 14.705 4.11zM14.135 4.68l-.649.649a4.9 4.9 0 0 1-6.907 6.907l-.648.648a5.85 5.85 0 0 0 8.205-8.205M9.75 4.4a4.1 4.1 0 1 0 0 8.2 4.1 4.1 0 0 0 0-8.2",
    clipRule: "evenodd"
  })));
};
export default SvgWebsite;